// extracted by mini-css-extract-plugin
export var anticlockwise = "V_dn";
export var svg = "V_dl";
export var wrapper = "V_B";
export var wrapperFlexCenter = "V_dm";